import React, { useState } from 'react';
import { View, Radio, Text, Divider } from '@upstox/upstox-ui';
import Modal from 'app/components/MainLayout/components/Modal';
import { ModalFooter } from 'app/components/MainLayout/components/Modal/ModalFooter';
import { CleverTapService } from 'modules/CleverTap';

interface ChangeThemeModalProps {
  onClose: () => void;
  handleSaveTheme: (theme: ThemeKeys) => void;
  themeOptions: ThemeKeys[];
  defaultValue?: ThemeKeys;
}

const themeList: Record<string, string> = {
  dark: 'Dark theme',
  light: 'Light theme',
  auto: 'Auto',
};

export const ChangeThemeModal = ({
  onClose,
  themeOptions,
  handleSaveTheme,
  defaultValue = 'auto',
}: ChangeThemeModalProps) => {
  const [selectedTheme, setSelectedTheme] = useState<ThemeKeys>(defaultValue);

  return (
    <Modal onClose={onClose} title="Change Theme">
      {themeOptions.map(option => (
        <View key={option} as="div" gap="medium" margin={['small', 'xlarge']}>
          <Radio
            style={{ outline: 'none' }}
            name="notification-types"
            value={option}
            id={option}
            checked={option === selectedTheme}
            onChange={e => setSelectedTheme(e.currentTarget.value as ThemeKeys)}
          />
          <Text htmlFor={option} as="label" family="tvFont">
            {themeList[option]}
          </Text>
        </View>
      ))}
      <Divider />
      <ModalFooter
        onClose={onClose}
        confirmActionTitle="Save"
        onConfirm={() => {
          handleSaveTheme(selectedTheme);
          CleverTapService.requestPermission();
          onClose();
        }}
      />
    </Modal>
  );
};
